import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllCustomers = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 99999,
  location = [],
  country = [],
  city = [],
  rate = {},
  sort = [],
  role = "",
  allIds = []
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    billingInformation: {
      country: {
        $in: country[0],
      },
      city: {
        $in: city[0],
      },
    },
  };

  if (rate.from && !rate.to) {
    assetFilters.billingInformation.rate = {
      $gte: rate.from,
    };
  } else if (!rate.from && rate.to) {
    assetFilters.billingInformation.rate = {
      $lte: rate.to,
    };
  } else if (rate.to && rate.from) {
    assetFilters.billingInformation.rate = {
      $gte: rate.from,
      $lte: rate.to,
    };
  }

  if (location?.length == 0 && role !== "super_admin") {
    assetFilters.locations = {
      id: {
        $in: allIds,
      },
    };
  } else {
    assetFilters.locations = {
      id: {
        $in: location,
      },
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "user",
      "billingInformation",
      "contactInformation",
      "logo",
      "parts",
      "assets",
      "createdByUser",
      "updatedByUser",
      "locations",
      "locations.parentLocation",
      "location",
      "createdByUser.profileImage",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `customers?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
